/**
 * sessionStorage 存储
 */
class Session {
  constructor() {
    this.session = window.sessionStorage;
    this.prefix = '';
  }
  set(key, value) {
    this.session.setItem(this.prefix + key, JSON.stringify(value));
  }
  get(key, fun) {
    let value = this.session.getItem(this.prefix + key);
    try {
      value = JSON.parse(value);
      if (!value) value = null;
    } catch (e) {
      value = null;
    }
    return typeof fun === 'function' ? fun.call(this, value) : value;
  }
  clear() {
    this.session.clear();
  }
}
export default new Session();
